import SC from 'soundcloud';
import React, { Component } from 'react';
import { Route, Switch, HashRouter, BrowserRouter as Router, Redirect } from 'react-router-dom';
import Modal from '@material-ui/core/Modal';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {Helmet} from 'react-helmet'

import './App.css';
import './Mobile.css';
import './Animation.css';
import About from './components/About';
import Stream from './components/Stream';
import Header from './components/Header';
import Player from './components/Player';
import Genre from './components/Genre';
import Events from './components/Events';
import { Social } from './components/Social'
import MyModal from './components/MyModal';
import platines from './assets/platines.svg'
import event from './assets/event.svg'
import platinesw from './assets/platinesw.png'
import eventw from './assets/eventw.png'
import { CLIENT_ID } from './constants/auth';
import { GENRE } from './constants/Genre'
import SCW from './sc.js';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-127299030-1');
/*ReactGA.pageview('/');
ReactGA.pageview('/#Disco-Funk');
ReactGA.pageview('/#House');
ReactGA.pageview('/#Deep House');
ReactGA.pageview('/#Techno');
ReactGA.pageview('/#About');
*/


SC.initialize({ client_id: CLIENT_ID });
console.log("ga ok")
class App extends Component {
  constructor(props) {
    super(props);
    this.frame = React.createRef();
    this.albumList = React.createRef();
    this.widget = null;
    this.emptyWidget = SCW.Widget;
    this.state = {
      tracks: [],
      chosenTrack: null,
      isPaused: true,
      index: null,
      chosenGenre: GENRE[0].id,
      chosenGenreName: GENRE[0].name,
      autoplay: "",
      albumRef: "",
      volume: 100.00,
    };
    this.changeTrack = this.changeTrack.bind(this)
    this.getTracks = this.getTracks.bind(this)
    this.changeGenre = this.changeGenre.bind(this)
    this.pauseTrack = this.pauseTrack.bind(this)
    this.playTrack = this.playTrack.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.timeout = null
  }
  fireTracking() {
    ReactGA.pageview(window.location.hash);
    console.log(window.location.hash)
  }
  changeTrack(data, index) {
    var cond = (this.state.isPaused === false && data === this.state.chosenTrack) ? this.pauseTrack() : this.playTrack();
    /*const _ = (this.state.isPaused === false && data === this.state.chosenTrack) ? ref.style['animation-play-state'] = 'paused' : ref.style['animation-play-state'] = 'running';*/
    this.setState({
      chosenTrack: data,
      index: index,
      autoplay: "autoplay",
      isPaused: !this.state.isPaused,
      //albumRef: ref
    })
  }
  changeGenre(id, name) {
    this.setState({
      chosenGenre: id,
      chosenGenreName: name,
      autoplay: "autoplay"
    })
  }
  getTracks(data, id) {
    this.setState({
      tracks: data, //.tracks.reverse()
      //chosenTrack: (id) ? id : this.state.chosenTrack
    })
  }
  pauseTrack() {
    this.widget.pause()
  }
  playTrack() {
    this.widget.play()
  }
  escFunction(e, active, tracks, ref) {
    switch (e.keyCode) {
      case 32:// Space button
        e.preventDefault()
        var cond = (this.state.isPaused === false) ? this.pauseTrack() : this.playTrack();
        var currentSpinner = this.albumList.current.state.currentSpinner
        const _ = (this.state.isPaused === false) ? currentSpinner.style['animation-play-state'] = 'paused' : currentSpinner.style['animation-play-state'] = 'running';
        this.setState({
          isPaused: !this.state.isPaused
        })
        break;
      case 40: //Down Arrow
        e.preventDefault()
        clearTimeout(this.timeout)
        this.refs.volume.style["display"] = 'initial'
        var currentVol = this.state.volume
        this.widget.getVolume((resp) => {
          this.currentVol = resp
        })
        var newVol = (currentVol < 5) ? 0 : currentVol - 5
        this.widget.setVolume(newVol)
        this.setState({
          volume: newVol
        });
        this.timeout = setTimeout(() => this.refs.volume.style["display"] = 'none', 2000)
        break;
      case 38:// Up Arrow
        e.preventDefault()
        clearTimeout(this.timeout)
        this.refs.volume.style["display"] = 'initial'
        var currentVol = this.state.volume
        this.widget.getVolume((resp) => {
          this.currentVol = resp
        })
        var newVol = (currentVol > 95) ? 100 : currentVol + 5
        this.widget.setVolume(newVol)
        this.setState({
          volume: newVol
        });
        this.timeout = setTimeout(() => this.refs.volume.style["display"] = 'none', 2000)
        break;
    }
    //alert(e.keyCode)
  }
  render() {
    return (
      <HashRouter onUpdate={this.fireTracking} hashType="noslash" >
        <div className="App">
        <Helmet>
    <title>Cosmic Moons - Discovering Gems</title>
    <meta name="robots" content="index, follow, noarchive"/>
    <meta name="description" content="Cosmic Moons is a concept created by two friends who love music, love to party, and want to share their passion.

After participating in the biggest parties organized worldwide, we wanted to bring something different, a personal touch. We have created a platform which will allow us to share our favorite music, meet new people, and build a community. You will be able to see theses artists perform at the events we organize all year round. They will be from everywhere, with different backgrounds and music genres.


Cosmix sessions will also be uploaded regularly, as well as info on the artists we will be hosting so that everyone can follow and/or discover who we’re listening to. We are aiming to collaborate with anyone who we think can make our events that much more special and unique. Our greatest advantage is the network we have created by discovering and sharing our passion with people all over the world.


We do not host any songs and have no rights to the songs posted. They are posted by the artists themselves on external platforms, we just relay them. For any complaint, do not hesitate to contact us."/>

  </Helmet>
          <div className="Main-container">
            <ReactCSSTransitionGroup
              transitionName="example"
              transitionAppear={true}
              transitionAppearTimeout={8000}
              transitionEnterTimeout={1000}
              transitionLeave={true}
              transitionLeaveTimeout={1000}>
            </ReactCSSTransitionGroup>
            <div className="volume" style={{ width: this.state.volume + "vw", display: 'none' }} ref='volume'></div>
            <Header>
              <MyModal name="Events" left={false} className="ModalBtn" icon={platines} iconClose={platinesw}>
                <Genre changeGenre={this.changeGenre} chosenGenre={this.state.chosenGenre} className='ModalComp' modal={true}>
                </Genre>
              </MyModal>
            </Header>
            <div className="Container-body">
              <Genre changeGenre={this.changeGenre} chosenGenre={this.state.chosenGenre}>
                <Social />
              </Genre>
              <Switch>
                <Route exact path={"/"} render={() => (<Redirect to='Disco-Funk' />)} />
                {
                  GENRE.map((genre, key) => {
                    if (genre.id > 1) {
                      return (
                        <Route path={"/" + genre.name} testing={this.state.chosenTrack} key={key} render={(props) => (
                          <Stream
                            {...props}
                            currentTrack={this.state.chosenTrack}
                            escFunction={this.escFunction}
                            genre={genre.name}
                            getTracks={this.getTracks}
                            handler={this.changeTrack}
                            isPaused={this.state.isPaused}
                            pauseTrack={this.pauseTrack}
                            player={this.frame}
                            playlist={genre.id}
                            playTrack={this.playTrack}
                            landTrack={this.landTrack}
                            ref={this.albumList}
                            widget={this.widget}
                          >
                          </Stream>)}
                        />
                      )
                    } else {
                      if (genre.id === 1) {
                        return (
                          <Route path={"/" + genre.name} key={key} render={(props) => (
                            <About />
                          )} />
                        )

                      } else {
                        return (
                          <Route path={"/" + genre.name} key={key} render={(props) => (
                            <Events />
                          )} />
                        )
                      }
                    }
                  })
                }
              </Switch>
            </div>
            <Player ref={this.frame} id={this.state.chosenTrack} autoplay={this.state.autoplay} />
          </div>
        </div>
      </HashRouter>
    );
  }
  componentDidMount() {
    console.log("If you're so curious, come check our event !\n\n https://www.facebook.com/events/289730374964956/")
    this.widget = SCW.Widget(this.frame.current)
    // this.widget.load('https://soundcloud.com/deep-house-london/premiere-shunus-lame-deer-geist-remix-wayu-records#t=0:00')
  }
  componentWillUpdate() {
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js